import React from "react";
import { motion } from "framer-motion";

export function Section({ children, className = "", id, dark = false, testId }) {
  return (
    <section id={id} data-testid={testId} className={`py-20 md:py-28 ${dark ? "bg-navy-900 text-ivory" : "bg-ivory text-navy-900"} ${className}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">{children}</div>
    </section>
  );
}

export function Eyebrow({ children, dark = false }) {
  return (
    <div className={`gold-divider ${dark ? "text-gold" : ""} mb-5`}>
      <span className="label-eyebrow whitespace-nowrap">{children}</span>
    </div>
  );
}

export function SectionTitle({ title, subtitle, center = false, dark = false, italic }) {
  return (
    <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""} mb-14`}>
      <h2 className={`serif text-4xl md:text-6xl leading-[1.05] tracking-tight ${dark ? "text-ivory" : "text-navy-900"}`}>
        {title} {italic && <em className="text-shimmer not-italic">{italic}</em>}
      </h2>
      {subtitle && <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-ivory/70" : "text-navy-900/50"}`}>{subtitle}</p>}
    </div>
  );
}

export function FadeIn({ children, delay = 0, y = 30, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
